export const EnvironmentType = {
    dev: 'Development',
    prod: 'Production',
    staging: 'Staging',
    local: 'Local'
}